import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { SurveyStatusEnum, SurveyTriggerTime, SurveyTriggerType } from '@/models'
import { resetQueries } from '@/utils'

import { USE_GET_SURVEYS_QUERY_KEY } from './get-surveys'

interface StopSurveyRequest {
  startTriggerDays?: number
  startTriggerTime?: SurveyTriggerTime
  startTriggerType?: SurveyTriggerType
  surveyId: number
}

export const stopSurvey = async ({ surveyId, ...payload }: StopSurveyRequest) => {
  const response = await authAPI.put(`/survey/${surveyId}`, {
    status: SurveyStatusEnum.enum['On hold'],
    ...payload,
  })
  return response.data
}

export const useStopSurvey = () => {
  return useMutation({
    mutationFn: stopSurvey,
    onSuccess: () => {
      resetQueries([USE_GET_SURVEYS_QUERY_KEY])
    },
  })
}
